import { Dayjs } from 'dayjs';
import { BannerFormValues } from './types';
import { IBanner } from './types';

export const checkCommonFieldsChanged = (values: BannerFormValues, id: string | undefined, bannerData: IBanner) => {
  if (!id || !bannerData) return;

  // Normalize dates to compare only the date part without timezone
  const normalizeDate = (date: string | null) => {
    if (!date) return null;
    // Ensure we're working with a proper date string
    const dateStr = date.split('T')[0];
    // Split into parts and ensure each part is properly formatted
    const [year, month, day] = dateStr.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  // Handle dayjs objects from form values
  const formatDayjs = (date: Dayjs | null) => {
    if (!date) return null;
    return date.format('YYYY-MM-DD');
  };

  const newEndDate = values.endDate ? formatDayjs(values.endDate) : null;
  const newStartDate = values.startDate ? formatDayjs(values.startDate) : null;
  const newLink = values.link;

  const originalEndDate = normalizeDate(bannerData.displayEndDate);
  const originalStartDate = normalizeDate(bannerData.displayStartDate);

  // Only check the common fields: endDate, startDate, and link
  return newEndDate !== originalEndDate || newStartDate !== originalStartDate || newLink !== bannerData.linkUrl;
};
